// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const IdeaIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="IdeaIcon" ref={forwardedRef} {...props}>
      <path d="M10.75 3V.5h-1.5V3z" />
      <path d="M13.482 4.018 15.25 2.25l1.06 1.06-1.767 1.768z" />
      <path d="M14.496 8.996a4.5 4.5 0 0 1-2.124 3.822v1.18a1 1 0 0 1-1 1H8.62a1 1 0 0 1-1-1v-1.18a4.5 4.5 0 1 1 6.876-3.822m-3.623 2.87a3.001 3.001 0 0 0-.877-5.87 3 3 0 0 0-.87 5.872v1.63h1.747z" />
      <path d="M7.625 17.238a.75.75 0 0 1 .75-.75h3.25a.75.75 0 0 1 0 1.5h-3.25a.75.75 0 0 1-.75-.75" />
      <path d="M4.25 6.5h-2.5V8h2.5z" />
      <path d="M18.25 6.5h-2.5V8h2.5z" />
      <path d="m4.75 2.25 1.768 1.768-1.06 1.06-1.769-1.767z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const IdeaIcon = /* @__PURE__ */ Object.assign(IdeaIconComponent, {
  displayName: 'IdeaIcon',
});
